<template>
  <div class="user-info-edit-wrapper">
    <transition
      name="user-info-edit-transition"
      enter-active-class="slideInRight"
      leave-active-class="slideOutRight">
    </transition>
    <CommonHeader title="프로필 편집" :is-back-btn="true" :back-fn="close" :is-close-btn="false"/>

    <div class="my-member-wrap">
      <div class="my-member-top">
        <!-- 다회선 사용자(2, 3회선)-->
        <div class="my-member-modify">
            <span class="profile-img-box">
                <span class="profile-img" v-for="(profile, index) in profiles.list" :key="'profile' + index" @click.prevent="()=>openEditOneOfProfile(index)">
                    <img :src="getImage(profile.image)" :alt="profile.alt" class="profile-sample-img">
                    <span class="profile-img-txt">{{profile.profilename}}</span>
                    <EditPencil/>
                </span>
            </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UserService } from '@/common/api/api.service'
import EditPencil from '@/assets/svg/common/ic-pencil.svg'
import utils from '@/common/util/utils'
import { PATH_NAME_LNB_EDIT_USER_ONE_OF_PROFILE } from '@/common/router.const'
import CommonHeader from '@/components/header/template/commonHeader'
import { isApp } from '@/common/util/common'
import { resizeThumbnail } from '@/common/image.filter'
export default {
  name: 'LnbEditUserProfile',
  props: ['closeFn'],
  components: {
    CommonHeader,
    EditPencil
  },
  data () {
    return {
      showEditOneOfProfile: false,
      profiles: {}
    }
  },
  methods: {
    getImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: '20', quality: 80 })
    },
    close () {
      this.$router.back()
    },
    openEditOneOfProfile (index) {
      this.$router.push({
        name: PATH_NAME_LNB_EDIT_USER_ONE_OF_PROFILE,
        params: {
          profileNumber: index
        }
      })
    },
    closeEditOneOfProfile () {
      this.setData()
      this.$router.back()
    },
    setData () {
      const credential = isApp() ? utils.cookies.getCredential() : utils.cookies.userInfo('credential')
      UserService.profiles({ offset: 0, limit: 10, orderby: 'new', credential: credential }).then(({ data }) => {
        this.profiles = data
      })
    }
  },
  created () {
    this.setData()
  }

}
</script>

<style scoped>
  .user-info-edit-wrapper {
    position: absolute;
    width: 100%;
    /*height: 100%;*/
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 4200;
    background-color: #1b1b1b;
  }

</style>
